import { Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-lnr-okta-callback',
  templateUrl: './lnr-okta-callback.component.html',
})
/**
 * Makes usage of okta callback component's error!
 */
export class LnrOktaCallbackComponent implements OnChanges {
  @Input() error?: string;

  /**
   * @constructor
   */
  constructor(private readonly router: Router) {}

  /**
   * If we have an error, pop up warning and allow redirection to home
   */
  ngOnChanges() {
    if (this.error) {
      this.reroute();
    }
  }

  /**
   * Reroutes to home page
   */
  reroute() {
    this.router.navigate([RoutesKeys.HOME]);
  }
}
